module.exports = __webpack_public_path__ + "media/icons/check-54cc9e30.svg";